<nav class="navbar sticky-top navbar-dark navbar-expand-lg" *ngIf="isLoggedIn()">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <a class="navbar-brand" [routerLink]="['/']">Airtotaal</a>
  <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="['/customers']">Customers</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="['/machines']">Machines</a>
      </li>
      <li class="nav-item" *ngIf="isAdmin()" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="['/agenda']">Agenda</a>
      </li>
      <li class="nav-item" *ngIf="isAdmin()" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="['/users']">Users</a>
      </li>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item" [routerLinkActive]="['active']">
        <a class="nav-link" [routerLink]="['/settings']">Instellingen</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']">
        <button class=" btn btn-link nav-link" (click)="logout()">Uitloggen</button>
      </li>
    </ul>
  </div>
</nav>

<p-confirmDialog header="Bevestiging" icon="fa fa-question-circle" width="425"></p-confirmDialog>

<div class="container-fluid">
  <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html